import React, { useEffect, useState } from "react";
import axios from "axios";
import TopHeader from "../component/TopHeader";
import Secondheader from "../component/Second_header";
import SkyBlueBox from "../component/SkyBlueBox";
import MachineItem from "../component/MachineItem";
import ServiceRequestItem2 from "../component/ServiceRequestitem2";
import "../component/css/User-machines.css";
import menimage from "../Image/Men.png";
import PopupComponent from "../component/PopupComponent";
import "../component/css/ServiceRequest.css";

const UserMachines = () => {
  const [activeTab, setActiveTab] = useState("Machines");
  const [serviceRequests, setServiceRequestsData] = useState([]);
  const [assignedEngineers, setAssignedEngineers] = useState([]);
  const [cmaMachines, setCmaMachines] = useState([]);
  const [welcomeData, setWelcomeData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [serviceLoading, setServiceLoading] = useState(false);
  const [isServiceRequestsLoaded, setIsServiceRequestsLoaded] = useState(false);
  const [pageNumber, setPageNumbers] = useState(1);
  const [totalRecords, setTotalRecords] = useState(0);

  const perPage = 10;

  const itemsPerPage = 10;
  const [customerEmail, setCustomerEmail] = useState(
    sessionStorage.getItem("email")
  );

  const fetchCustomerEmail = (interval = 500) => {
    return new Promise((resolve) => {
      const checkEmail = () => {
        const email = sessionStorage.getItem("email");
        if (email) {
          setCustomerEmail(email);
          resolve(email);
        } else {
          setTimeout(checkEmail, interval);
        }
      };
      checkEmail();
    });
  };

  useEffect(() => {
    if (!customerEmail) {
      fetchCustomerEmail().then((email) => {
        if (email) {
          fetchAllData(email);
          fetchServiceRequests(email);
        }
      });
    } else {
      fetchAllData(customerEmail);
      fetchServiceRequests(customerEmail);
    }
  }, []);

  const fetchServiceRequests = (email) => {
    if (!email) return;

    console.log("Fetching service requests for:", email, "Page:", pageNumber);

    setServiceLoading(true);
    axios
      .get("/server/jad_group_website_function/service_request", {
        params: {
          Customer_Email: email,
          Page: pageNumber,
          perPage: perPage,
        },
      })
      .then((response) => {
        console.log("Fetched Data:", response.data);

        setServiceRequestsData(response.data["Service Requests"] || []);
        setTotalRecords(response.data["Total Service Requests"] || 0);
        setServiceLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching service requests:", error);
        setServiceLoading(false);
      });
  };

  useEffect(() => {
    console.log("pageNumber changed:", pageNumber);
    if (customerEmail) {
      fetchServiceRequests(customerEmail, pageNumber);
    }
  }, [pageNumber, customerEmail]);

  const handleCreateServiceRequestClick = () => {
    if (!isPopupOpen) {
      setIsPopupOpen(true);
      setActiveTab(false);
    }
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
    setActiveTab("Machines" && "Service Requests");
  };

  const fetchAllData = (email) => {
    if (!email) return;

    setLoading(true);
    Promise.allSettled([
      axios.get("/server/jad_group_website_function/user_machines", {
        params: { Customer_Email: email },
      }),
      axios.get("/server/jad_group_website_function/assigned_engineers", {
        params: { Customer_Email: email },
      }),
      axios.get("/server/jad_group_website_function/CMA-machines", {
        params: { Customer_Email: email, Page: 1, perPage: 10 },
      }),
    ])
      .then(([welcomeResult, engineersResult, machineResult]) => {
        if (welcomeResult.status === "fulfilled") {
          setWelcomeData(welcomeResult.value.data);
        }
        if (engineersResult.status === "fulfilled") {
          setAssignedEngineers(engineersResult.value.data);
        }
        if (machineResult.status === "fulfilled") {
          setCmaMachines(machineResult.value.data);
        }
        setLoading(false);
      });
  };

  useEffect(() => {
    if (customerEmail) {
      fetchServiceRequests(customerEmail, pageNumber);
    }
  }, [pageNumber, customerEmail]);

  const handleTabClick = (tab) => {
    setActiveTab(tab);
    if (tab === "Service Requests" && !isServiceRequestsLoaded) {
      fetchServiceRequests();
    }
  };

  const handleNextPage = () => {
    console.log("-----hbhbhbh----------");

    setPageNumbers((prevPage) => {
      const newPage = prevPage + 1;
      console.log("---------------", pageNumber);

      fetchServiceRequests(customerEmail, newPage);
      return newPage;
    });
  };

  const handlePrevPage = () => {
    setPageNumbers((prevPage) => {
      if (prevPage > 1) {
        const newPage = prevPage - 1;
        fetchServiceRequests(customerEmail, newPage);
        return newPage;
      }
      return prevPage;
    });
  };

  const totalMachines = cmaMachines?.["Total CMA Machines"] || 0;
  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const totalPages = Math.ceil(totalMachines / itemsPerPage);


  if (loading) {
    return (
      <div
        className="loader"
        style={{ textAlign: "center", marginTop: "350px" }}
      ></div>
    );
  }

  return (
    <div className="UserMachines_box">
      <TopHeader />
      <div className="secondHeader-fixed-style">
        <Secondheader />
      </div>

      <div className="Inside_details">
        <div className="Dashboard_hero">
          <div className="Dashboard_hero_overlay" aria-hidden="true" />
          <div className="Dashboard_hero_content">
            <div className="Dashboard_hero_text">
              <h1 className="Dashboard_hero_title">
                Welcome back{welcomeData?.Name ? ", " : ""}
                {welcomeData?.Name && <span>{welcomeData.Name}</span>}
              </h1>
              <p className="Dashboard_hero_subtitle">
                Manage your equipment and service requests in one place.
              </p>
              <button
                type="button"
                className="Dashboard_hero_cta"
                onClick={handleCreateServiceRequestClick}
              >
                + Create Service Request
              </button>
            </div>
            <div className="Dashboard_hero_stats">
              <div className="Dashboard_stat_card">
                <div className="Dashboard_stat_icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <rect x="3" y="4" width="18" height="6" rx="1" />
                    <rect x="3" y="14" width="18" height="6" rx="1" />
                    <line x1="7" y1="7" x2="7.01" y2="7" />
                    <line x1="7" y1="17" x2="7.01" y2="17" />
                  </svg>
                </div>
                <div className="Dashboard_stat_meta">
                  <span className="Dashboard_stat_value">
                    {welcomeData?.["CMA Machines"] ?? 0}
                  </span>
                  <span className="Dashboard_stat_label">
                    Total CMA Machines
                  </span>
                </div>
              </div>
              <div className="Dashboard_stat_card">
                <div className="Dashboard_stat_icon" aria-hidden="true">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                    <path d="M9 11l3 3L22 4" />
                    <path d="M21 12v7a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2h11" />
                  </svg>
                </div>
                <div className="Dashboard_stat_meta">
                  <span className="Dashboard_stat_value">
                    {welcomeData?.["Service Requests"] ?? 0}
                  </span>
                  <span className="Dashboard_stat_label">
                    Active Service Tickets
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="Two_boxes">
          <div className="First_BOX">
            <p className="Text_up">
              Your Assigned Engineers{" "}
              <span>({assignedEngineers?.["Total Assigned Engineers"]})</span>
            </p>
            {(assignedEngineers?.["Assigned Engineers"] || []).map((engineer, index) => (
              <SkyBlueBox
                key={index}
                imageUrl={menimage}
                name={engineer.Name}
                email={engineer.Email}
                phone={engineer.Mobile}
                machineName={engineer["Machine Name"]}
              />
            ))}
          </div>

          <div className="Second_BOX">
            <div className="Top_Button">
              <div className="tab-buttons-left">
                <p
                  className={`Button ${
                    activeTab === "Machines" ? "ActiveButton" : ""
                  }`}
                  onClick={() => handleTabClick("Machines")}
                >
                  Machines
                </p>
                <p
                  className={`Button ${
                    activeTab === "Service Requests" ? "ActiveButton" : ""
                  }`}
                  onClick={() => handleTabClick("Service Requests")}
                >
                  Service Requests
                </p>
              </div>
              <button
                className="Create-Service-Btn"
                onClick={handleCreateServiceRequestClick}
              >
                + Create Service Request
              </button>
            </div>
            {isPopupOpen && (
              <PopupComponent
                onClose={handleClosePopup}
                isPopupOpen={isPopupOpen}
                email={customerEmail}
                hideOwner={true}
              />
            )}

            <div
              className={`Second_BOX_part ${
                activeTab === "Machines" ? "" : "d-none"
              }`}
              id="Machines"
            >
              {cmaMachines &&
              cmaMachines["CMA Machines"] &&
              cmaMachines["CMA Machines"].length > 0 ? (
                cmaMachines["CMA Machines"].map((machine, index) => (
                  <MachineItem
                    key={index}
                    recordId={machine["Record Id"]}
                    imageUrl={`https://via.placeholder.com/150?text=${machine["Machine Name"]}`}
                    topNumber1={machine["Machine Name"]}
                    status={machine["Status"]}
                    manufacture={machine["Manufacturer"]}
                    model={machine["Model"]}
                    serviceTickets={machine["Service Tickets"]}
                    cmaStartDate={machine["CMA Start Date"]}
                    cmaBalance={{
                      partsCapRemaining: machine["Parts Cap Remaining"],
                      calibrationRemaining: machine["Calibrations Remaining"],
                      supportHours: machine["Remote Support Hours Remaining"],
                      onSiteServiceVisit:
                        machine["On Site Service Visits Remaining"],
                    }}
                  />
                ))
              ) : (
                <div style={{
                  textAlign: 'center',
                  padding: '60px 20px',
                  color: '#666',
                }}>
                  <div style={{ fontSize: '48px', color: '#d0d6df', marginBottom: '10px' }}>⚙</div>
                  <h3 style={{ color: '#145C91', margin: '0 0 8px 0', fontFamily: 'Open Sans, sans-serif' }}>
                    No machines found
                  </h3>
                  <p style={{ color: '#808490', fontSize: '13px', margin: 0, fontFamily: 'Open Sans, sans-serif' }}>
                    You currently have no CMA machines assigned to your account.
                  </p>
                </div>
              )}
              <div className="pagination">
                <div>
                  <h6 style={{ color: "grey" }}>
                    You have a total of {totalMachines} CMA Machines
                  </h6>
                </div>
                <div className="page_buttons">
                  <button
                    className="pre-button"
                    disabled={currentPage === 1}
                    onClick={() => handlePageChange(currentPage - 1)}
                  >
                    Previous
                  </button>
                  {[...Array(totalPages)].map((_, index) => (
                    <button
                      key={index}
                      className={`pagination-button ${
                        currentPage === index + 1 ? "active" : ""
                      }`}
                      onClick={() => handlePageChange(index + 1)}
                    >
                      {index + 1}
                    </button>
                  ))}
                  <button
                    className="next-button"
                    disabled={currentPage === totalPages}
                    onClick={() => handlePageChange(currentPage + 1)}
                  >
                    Next
                  </button>
                </div>
              </div>
            </div>

            <div
              className={`Second_BOX_part ${
                activeTab === "Service Requests" ? "" : "d-none"
              }`}
              id="Service Requests"
            >
              {serviceLoading ? (
                <div className="loaderStyleLoader">
                  <div className="spinner"></div>
                </div>
              ) : (
                <div className="Flex-Details">
                  {serviceRequests && serviceRequests.length > 0 ? (
                    <table style={{ width: "100%", borderCollapse: "collapse", fontFamily: "Open Sans, sans-serif" }}>
                      <thead>
                        <tr style={{ borderBottom: "1px solid #dcdcdc", position: "sticky", top: 0, backgroundColor: "#fff" }}>
                          <th style={{ width: "15%", textAlign: "left", padding: "10px 15px", fontSize: "14px", fontWeight: 600, color: "#333" }}>SR No.</th>
                          <th style={{ width: "25%", textAlign: "left", padding: "10px 7px", fontSize: "14px", fontWeight: 600, color: "#333" }}>Description</th>
                          <th style={{ width: "20%", textAlign: "left", padding: "10px 7px", fontSize: "14px", fontWeight: 600, color: "#333" }}>Machine Name</th>
                          <th style={{ width: "15%", textAlign: "left", padding: "10px 7px", fontSize: "14px", fontWeight: 600, color: "#333" }}>Type</th>
                          <th style={{ width: "10%", textAlign: "left", padding: "10px 7px", fontSize: "14px", fontWeight: 600, color: "#333" }}>Status</th>
                        </tr>
                      </thead>
                      <tbody>
                        {serviceRequests.map((request, index) => (
                          <ServiceRequestItem2
                            key={index}
                            request={request}
                            loading={serviceLoading}
                          />
                        ))}
                      </tbody>
                    </table>
                  ) : (
                    <p style={{ textAlign: "center", color: "gray" }}>
                      No service requests found.
                    </p>
                  )}

                  <div style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px 15px",
                    borderTop: "1px solid #eee",
                    marginTop: "10px",
                    fontFamily: "Open Sans, sans-serif",
                  }}>
                    <p style={{ color: "#808490", fontSize: "13px", margin: 0 }}>
                      You have total {totalRecords} Service Records
                    </p>

                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <button
                        onClick={handlePrevPage}
                        disabled={pageNumber === 1}
                        style={{
                          backgroundColor: pageNumber === 1 ? "#ddd" : "#fff",
                          color: pageNumber === 1 ? "#999" : "#333",
                          border: "1px solid #ddd",
                          padding: "6px 14px",
                          borderRadius: "4px",
                          cursor: pageNumber === 1 ? "not-allowed" : "pointer",
                          fontSize: "13px",
                          fontFamily: "Open Sans, sans-serif",
                        }}
                      >
                        Previous
                      </button>
                      <span style={{
                        backgroundColor: "#017cc2",
                        color: "#fff",
                        padding: "6px 12px",
                        borderRadius: "4px",
                        fontSize: "13px",
                        fontWeight: 600,
                      }}>
                        {pageNumber}
                      </span>
                      <button
                        onClick={handleNextPage}
                        disabled={totalRecords <= pageNumber * perPage}
                        style={{
                          backgroundColor: totalRecords <= pageNumber * perPage ? "#ddd" : "#fff",
                          color: totalRecords <= pageNumber * perPage ? "#999" : "#333",
                          border: "1px solid #ddd",
                          padding: "6px 14px",
                          borderRadius: "4px",
                          cursor: totalRecords <= pageNumber * perPage ? "not-allowed" : "pointer",
                          fontSize: "13px",
                          fontFamily: "Open Sans, sans-serif",
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default UserMachines;
